﻿export class JobFilters {
    public static wrapHeading($: JQueryStatic): void {
        if (document.body.classList.contains('page-redesign')) return
        const searchFiltersWidgetHeading = $(".search-filters-widget__heading");
        const filterText = searchFiltersWidgetHeading.text();
        const newFilterHtml =
            '<div class="filter-heading-wrapper">' + filterText + "</div>";
        searchFiltersWidgetHeading.html(newFilterHtml);
    }

    public static addClickHandlers($: JQueryStatic): void {
        if (document.body.classList.contains('page-redesign')) return
        $(".search-filters-widget__heading").on("click", function () {
            $(this).find(".filter-heading-wrapper").toggleClass("open");
            $(this)
                .parent()
                .find(".search-filters-widget__filter-list")
                .slideToggle();
        });

        $(".location-filter .header").on("click", function () {
            $(".optionfiltergroup").removeClass("category-opened");
            $(".option-display-list").slideUp();
            $(".option-type-header").removeClass("open");

            $(this).parent().find(".location-slider-wrapper").slideToggle();

            if ($(this).hasClass("open")) {
                $(this).removeClass("open");
            } else {
                $(this).addClass("open");
            }
        });

        $(".optionfiltergroup, .location-filter").on("click", function () {
            const elIdx = $(this).index();

            $(".jobs-filters-background__container > div").each(function (
                idx,
                val
            ) {
                if (elIdx === idx) {
                    if ($(this).hasClass("open")) {
                        $(this).removeClass("open");
                    } else {
                        $(
                            ".jobs-filters-background__container > div"
                        ).removeClass("open");
                        $(this).addClass("open");
                    }
                }
            });
        });

        $(".option-type-header-text").on("click", function () {
            $(".location-filter h3").removeClass("open");
            $(".location-slider-wrapper").slideUp();

            if ($(this).parent().hasClass("open")) {
                $(this).parent().removeClass("open");
            } else {
                $(".option-type-header").removeClass("open");
                $(this).parent().addClass("open");
            }
        });

        $(".filter-expand-hide").on("click", function (e) {
            e.stopPropagation();
            $(this).parent().find(".child-list").slideToggle();
            $(this).toggleClass("open");
        });

        $(".filter-option").on("click", function (e) {
            // e.stopPropagation();
        });

        $(".option-display-list").on("click", function (e) {
            e.stopPropagation();
        });
    }
}
